import React, { Component } from 'react';

class TermsAndConditions extends Component {
    constructor(props) {
        super(props);
        localStorage.setItem('catData',"");
    }
    render() {
        return (
            <section class="ovrfl">
                <div class="container">

                    <div class="row breadcrumb text-center trght">
                        <div class="col-md-12">
                            <span>Home</span> <i class="fa fa-angle-right"></i>
                            <span>Pages</span> <i class="fa fa-angle-right"></i>
                            <span>TERMS &amp; CONDITIONS </span>
                        </div>
                    </div>

                    <div class="row pad_0">
                        <div class="col-md-12 term_bg">

                            <h1 class="term-h">TERMS &amp; CONDITIONS</h1>

                            <p class="term-p">Mordor Intelligence provides their services to you subject to the following conditions. If you visit or shop at mordorintelligence.com, you accept these conditions. Please read them carefully. We reserve the right to make changes to these terms and conditions at our absolute discretion at anytime. Any such amendment shall be effective once the revised terms have been posted on the Site. Please contact the site administrator at <a target="_blank" href="mailto:info@mordorintelligence.com">info@mordorintelligence.com</a> with any queries / comments / concerns.</p>

                            <h2 class="term-h2">Shipping</h2>


                            <ul class="term-ul">
                                <li>All of our industry reports are sent via email as a pdf/ Word/ Excel documents.</li>
                            </ul>


                            <h2 class="term-h2">Delivery Time</h2>


                            <ul class="term-ul">
                                <li>When you place an order with Mordor Intelligence, we endeavor to deliver as soon as possible. Electronic delivery is generally done within 24 hours of purchase and pre-booked reports are delivered on the date of report release.</li>
                            </ul>



                            <h2 class="term-h2">Return/Refund Policy</h2>


                            <ul class="term-ul">
                                <li>The nature of the information being sold means that we cannot accept returns of or refund for products once they have been dispatched.</li>
                            </ul>


                            <h2 class="term-h2">Disclaimer</h2>


                            <ul class="term-ul">
                                <li>Mordor Intelligence is not responsible for any loss or damage suffered by you directly or indirectly, as a result of our delay in/failure to deliver the data/report due to circumstances beyond our control, including but not limited to natural disasters, labor strikes, war, riot, civil disorder, embargo and government regulations or restrictions of any and all kinds. Delivery time shall be extended in such conditions, allowing us reasonable time to fulfill your requirements.</li>

                                <li>Mordor Intelligence and its affiliates and sponsors are neither responsible nor liable for any direct, indirect, incidental, consequential, special, exemplary, punitive, or other damages arising out of or relating in any way to your use of our research.</li>

                            </ul>


                            <h2 class="term-h2">Copyright</h2>

                            <ul class="term-ul">
                                <li>You agree not to resell any part of the data/report you receive from us in a manner that competes with our products and services, without the express written permission of Mordor Intelligence.</li>

                            </ul>



                            <h2 class="term-h2">Terms &amp; Conditions for use of the content on the Site</h2>


                            <ul class="term-ul">
                                <li>The Copyright in all of the Copyright works contained within these pages is either owned by Mordor Intelligence LLP or licensed to it. Any part or all of the contents of any of these pages may not be used, distributed or copied for any commercial purpose unless otherwise noted.</li>

                                <li>The information on this Site has been included in good faith for general informational purposes only. The information should not be relied upon for any specific purpose and no representation or warranty is given as to its accuracy or completeness.</li>

                                <li>We shall not be liable to you for any loss that you suffer (including, without limitation, damages for any consequential loss or loss of business opportunities or projects, or loss of profits) howsoever arising, whether in contract, tort or otherwise from your use or inability to use this Site, or any of its contents, or from any action or omission taken as a result of using this Site provided that nothing in these terms shall exclude or limit our liability for personal injury or death caused by our negligence.</li>

                                <li>By submitting personal information via any of the online forms on the site, you consent to being contacted (either by phone or email) by a representative of Mordor Intelligence LLP.</li>

                            </ul>





                        </div>
                    </div>

                </div>
            </section>
        );
    }


}


export default TermsAndConditions;


// WEBPACK FOOTER //
// ./src/Misc/TermsAndConditions/TermsAndConditions.js